const ArrowLeft02Icon = /*#__PURE__*/ [
  ["path", { d: "M5.5 12.002H19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10.9999 18.002C10.9999 18.002 4.99998 13.583 4.99997 12.0019C4.99996 10.4208 11 6.00195 11 6.00195", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export { ArrowLeft02Icon as default };
//# sourceMappingURL=ArrowLeft02Icon.js.map
